import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import GroupIcon from "@mui/icons-material/Group";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import WbCloudyOutlinedIcon from "@mui/icons-material/WbCloudyOutlined";
import useMediaQuery from "@mui/material/useMediaQuery";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import List from "@mui/material/List";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Logo from "../../assets/images/megaconnectlogo svg.svg";
import Select from "@mui/material/Select";
import { styled } from "@mui/system";
import axios from "axios";

function Sidenav() {
  const [selectedItem, setSelectedItem] = useState("");
  const [notificationData, setNotificationData] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleItemClick = (itemName) => {
    setSelectedItem(itemName);
  };
  const isMobile = useMediaQuery("(max-width:900px)");
  const StyledMainBox = styled(Box)({
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "15px",
    marginTop: "10px",
    //  width:"100%"
  });
  const smallContent = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "14px",
    },
    // Other styles...
  };
  
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ed" : "#308fe8",
    },
  }));
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const FILE_LIST = `${SERVER_URI}/list`;
  const [totalBucketStorage, setTotalBucketStorage] = React.useState(null);
  const [storageUnit, setStorageUnit] = React.useState(null);
  const [progressValue, setProgressValue] = React.useState(0);

  const totalstorage = 50;
  // Function to fetch file list and total bucket storage from the API
  const fetchFileListAndStorage = async () => {
    try {
      let token = localStorage.getItem("accessToken");
      const response = await fetch(FILE_LIST, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();

      const totalStorageWithUnit = data.totalBucketSize; // e.g., "173.66 MB"
      setTotalBucketStorage(totalStorageWithUnit);

      const parts = totalStorageWithUnit.split(" ");
      const unit = parts[1];
      setStorageUnit(unit);

      const usedStorage = parseFloat(data.totalBucketSize.replace(" MB", "")); // Replace this with the actual usedStorage value
      const progressValue = (usedStorage / 10000) * 50;

      setProgressValue(progressValue);
    } catch (error) {
      console.error("Error fetching file list:", error);
    }
  };

  // Fetch file list and total bucket storage when the component mounts
  React.useEffect(() => {
    const fetchData = async () => {
      await fetchFileListAndStorage();
    };
    fetchData();
  }, []);
  return (
    <div >
       {!isMobile && (
      <StyledMainBox>
        <List>
          <img
            src={Logo}
            alt=""
            width={50}
            style={{ display: "flex", margin: "auto" }}
          />
          <ListItem disablePadding sx={{ marginTop: "30px" }}>
            <ListItemButton
              component={Link}
              to="/files"
              selected={selectedItem === "Home"}
              onClick={() => handleItemClick("Home")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Home" ? "#1D53E7" : "#5D7285",
                }}
              >
                <HomeOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Home"
                style={{
                  color: selectedItem === "Home" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Home" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              // to="/overview"
              selected={selectedItem === "Recent"}
              onClick={() => handleItemClick("Recent")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Recent" ? "#1D53E7" : "#5D7285",
                }}
              >
                <ScheduleOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Recent"
                style={{
                  color: selectedItem === "Recent" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Recent" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/favorites"
              selected={selectedItem === "Favourite"}
              onClick={() => handleItemClick("Favourite")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Favourite" ? "#1D53E7" : "#5D7285",
                }}
              >
                <FavoriteBorderOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Favourite"
                style={{
                  color: selectedItem === "Favourite" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Favourite" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/recyclebin"
              selected={selectedItem === "Recycle Bin"}
              onClick={() => handleItemClick("Recycle Bin")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Recycle Bin" ? "#1D53E7" : "#5D7285",
                }}
              >
                <DeleteOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Recycle Bin"
                style={{
                  color: selectedItem === "Recycle Bin" ? "#488cca" : "#5D7285",
                  fontWeight:
                    selectedItem === "Recycle Bin" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              // to="/overview"
              selected={selectedItem === "Support"}
              onClick={() => handleItemClick("Support")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Support" ? "#1D53E7" : "#5D7285",
                }}
              >
                <HandshakeOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Support"
                style={{
                  color: selectedItem === "Support" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Support" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>

          <ListItem
            disablePadding
            sx={{
              display: "block",
              marginTop: "30px",
              backgroundColor: "#B7FFFE",
              borderRadius: "8px",
            }}
          >
            <ListItemButton
              sx={{
                // minHeight: 48,
                justifyContent: "center",
                px: 2.5,
                display: "block",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {/* Icon and Text (Storage Used) */}
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    display: "flex",
                    alignItems: "center",
                    mr: 2, // Space between icon and text
                  }}
                >
                  <WbCloudyOutlinedIcon sx={{ color: "#1D53E7" }} />
                  <Typography
                    sx={{
                      ...smallContent.typography,
                      color: "#1D53E7",
                      marginLeft: "8px", // Space between icon and text
                    }}
                  >
                    Storage Used
                  </Typography>
                </ListItemIcon>
              </Box>

              {/* Progress Bar and Storage Info */}
              {/* <Box> */}
              <Grid
                container
                direction="column"
                alignItems="left"
                justifyContent="left"
                sx={{ mt: 1, width: "100%" }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    // Margin on top of progress bar
                    color: "#1F1F1F",
                    fontFamily: "Roboto Flex",
                    fontSize: "1rem",
                    lineHeight: "18px",
                    fontWeight: 500,
                  }}
                >
                  {`${totalBucketStorage} of ${totalstorage}GB`}
                </Typography>
                {/* Progress Bar */}
                <BorderLinearProgress
                  variant="determinate"
                  value={progressValue}
                  sx={{ width: "100%", mt: 2, mb: 2 }} // Full width progress bar
                />

                {/* Storage Usage Reading */}
              </Grid>
              {/* </Box> */}
            </ListItemButton>
          </ListItem>

          <ListItem
            disablePadding
            sx={{ mt: 2, backgroundColor: "#1D53E7", borderRadius: "24px",width:"100%" }}
          >
            <ListItemButton
              component={Link}
              // to="/overview"
              // selected={selectedItem === "Back to Dashboard"}
              onClick={() => handleItemClick("Back to Dashboard")}
              sx={{
                color: "white",
                width:"100%" 
              }}
            >
              <ListItemIcon
                sx={{
                  color: "white",
                }}
              >
                <DashboardCustomizeOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Back to Dashboard"
                sx={{
                  color: "white",
                  fontWeight: 500,
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                  width:"100%"
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </StyledMainBox>
      )}
    </div>
  );
}

export default Sidenav;
